// extracted by mini-css-extract-plugin
export default {"roleItem":"RolesPage_roleItem__zcDHa","roleItemSelected":"RolesPage_roleItemSelected__s+YnU","roleContent":"RolesPage_roleContent__Mo+wD","checkArea":"RolesPage_checkArea__7J3nn"};